import { render, staticRenderFns } from "./TicketDetailElement.vue?vue&type=template&id=91de95ec"
import script from "./TicketDetailElement.js?vue&type=script&lang=js&external"
export * from "./TicketDetailElement.js?vue&type=script&lang=js&external"
import style0 from "./TicketDetailElement.vue?vue&type=style&index=0&id=91de95ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports